<template>
    <Dialog v-model:open="open">
        <DialogTrigger as-child>
            <slot />
        </DialogTrigger>
        <DialogContent class="sm:max-w-[548px]">
            <DialogHeader>
                <template #icon>
                    <UserPlus class="text-z-primary-600" :size="20"></UserPlus>
                </template>
                <DialogTitle> {{ $t("teams.invite_to_team") }}</DialogTitle>
                <DialogDescription>
                    {{ $t("teams.invite_to_team_description") }}
                    <a
                        href="https://napoveda.zaptime.cz/prace-v-tymu.html#jak-zalozit-tym"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="ml-1 font-medium text-z-primary-600 hover:text-z-primary-500 underline"
                        >{{ $t("teams.learn_more_billing") }}</a
                    ></DialogDescription
                >
            </DialogHeader>

            <form @submit.prevent="inviteToTeam">
                <div class="mt-2 gap-4 px-6 py-4 grid grid-cols-[1fr_134px]">
                    <div class="max-w-sm gap-1.5 grid w-full items-center">
                        <Label for="domain">{{
                            $t("teams.member_email")
                        }}</Label>
                        <div class="relative">
                            <span
                                class="inset-y-0 start-0 px-3 absolute flex items-center justify-center"
                            >
                                <Mail class="size-6 text-iron-500" />
                            </span>
                            <Input
                                id="email"
                                class="pl-10"
                                v-model="email"
                                type="email"
                            />
                        </div>
                    </div>
                    <div class="max-w-sm gap-1.5 grid w-full items-center">
                        <RoleSelect v-model="role" />
                    </div>
                </div>
                <DialogFooter>
                    <DialogClose>
                        <Button variant="outline"> {{ $t("cancel") }}</Button>
                    </DialogClose>
                    <Button type="submit">
                        {{ $t("teams.invite_to_team_button") }}
                    </Button>
                </DialogFooter>
            </form>
        </DialogContent>
    </Dialog>
</template>

<script lang="ts" setup>
import Button from "@/components/ui/button/Button.vue";
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog-v2";
import DialogDescription from "@/components/ui/dialog-v2/DialogDescription.vue";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { router } from "@inertiajs/vue3";
import { Mail, UserPlus } from "lucide-vue-next";
import { ref } from "vue";
import route from "ziggy-js";
import type { Team } from "../types/Team";
import RoleSelect from "./RoleSelect.vue";

interface Props {
    team: Team;
}
const props = defineProps<Props>();

const open = ref(false);
const email = ref("");
const role = ref("editor");

async function inviteToTeam() {
    router.post(
        route("team-members.store", {
            team: props.team.id,
        }),
        {
            email: email.value,
            role: role.value,
        },
        {
            onFinish: () => {
                open.value = false;
            },
        },
    );
}
</script>
